import { Routes, Route } from "react-router-dom";

import BatteryList from "./BatteryList";
import SingleBatteryPage from "./SingleBatteryPage";

export default function App() {
    return (
        <Routes>
            <Route path="/" element={<BatteryList />} />
            <Route path="/:gbuid" element={<SingleBatteryPage />} />
        </Routes>
    );
}
